import { useEffect, useState } from 'react';

const estadosMap = {
  'Acre': 'AC',
  'Alagoas': 'AL',
  'Amapá': 'AP',
  'Amazonas': 'AM',
  'Bahia': 'BA',
  'Ceará': 'CE',
  'Distrito Federal': 'DF',
  'Espírito Santo': 'ES',
  'Goiás': 'GO',
  'Maranhão': 'MA',
  'Mato Grosso': 'MT',
  'Mato Grosso do Sul': 'MS',
  'Minas Gerais': 'MG',
  'Pará': 'PA',
  'Paraíba': 'PB',
  'Paraná': 'PR',
  'Pernambuco': 'PE',
  'Piauí': 'PI',
  'Rio de Janeiro': 'RJ',
  'Rio Grande do Norte': 'RN',
  'Rio Grande do Sul': 'RS',
  'Rondônia': 'RO',
  'Roraima': 'RR',
  'Santa Catarina': 'SC',
  'São Paulo': 'SP',
  'Sergipe': 'SE',
  'Tocantins': 'TO',
};

const useGeolocation = () => {
  const [location, setLocation] = useState(null);
  const [uf, setUf] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUF = async (lat, lon) => {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
        );
        const data = await response.json();
        const estado = data?.address?.state || '';
        const sigla = estadosMap[estado] || '';
        setUf(sigla); // Agora salva SP, RJ, etc.
      } catch (err) {
        console.error('Erro ao buscar UF:', err);
        setUf(null);
      }
    };

    const requestLocation = () => {
      if (!navigator.geolocation) {
        setError('Geolocalização não é suportada no seu navegador.');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          setLocation(coords);
          setError(null);
          fetchUF(coords.latitude, coords.longitude);
        },
        (err) => {
          setError(err.message || 'Permissão de localização negada.');
          setLocation(null);
          setUf(null);
        },
        {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    };

    requestLocation();
  }, []);

  return { location, uf, error };
};

export default useGeolocation;
